<template>
    <div>
        <ul class="action-button-list">
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li>
                <div class="wide-block pt-2 pb-2 placeholder-glow" data-bs-dismiss="offcanvas">
                    <span class="placeholder col-12"></span>
                </div>
            </li>
            <li class="action-divider"></li>
            <li>
                <a href="#" class="btn btn-list text-danger" data-bs-dismiss="offcanvas">
                    <span>بستن</span>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'Line'
}
</script>
<style></style>